// extracted by mini-css-extract-plugin
export default {"imageCont":"LogoPage_imageCont__giDRq","image":"LogoPage_image__slG7U","platformText":"LogoPage_platformText__xzGhg"};